import {ProductComboSteps} from '@/types/productComboTypes'
import {ProductComboDisplay} from './ProductComboDisplay'
import {ProductComboProducts} from './ProductComboProducts/ProductComboProducts'
import {ProductComboReview} from './ProductComboReview/ProductComboReview'
import {ProductComboSetup} from './ProductComboSetup/ProductComboSetup'
export {ProductComboSteps} from '@/types/productComboTypes'

/**
 * Resolves the Product Combination step content from the provided step number.
 * @param {{step: number}} props - Step component props.
 * @returns {JSX.Element|null} The rendered step content.
 */
export const ProductComboStep = ({step}) => {
  switch (step) {
    case ProductComboSteps.SETUP:
      return <ProductComboSetup />
    case ProductComboSteps.DISPLAY:
      return <ProductComboDisplay />
    case ProductComboSteps.PRODUCTS:
      return <ProductComboProducts />
    case ProductComboSteps.REVIEW:
      return <ProductComboReview />
    default:
      return null
  }
}
